/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./AreYouSureDialog.vue?vue&type=template&id=6a287171"
import script from "./AreYouSureDialog.ts?vue&type=script&lang=ts&external"
export * from "./AreYouSureDialog.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports